module.exports = __webpack_public_path__ + "img/coating-scratch-cover.7a917711.png";